<div class="p-3">
  <h2>Mentee rating - Progress</h2>
  <p class="text-xs">Check mentees’ progress after 3 months</p>
</div>
<div class="container-iframe">
  <iframe [src]="url" class="responsive-iframe"></iframe>
</div>
